export default "__VITE_ASSET__C2c9CCSA__"